export default __webpack_public_path__ + "static/media/plus.4b485c03.svg";